const translations = {
    en: {
        shared: {
            login: {
                insert_data: "Insert your data",
                access_your_home: "to access Your Home!",
                booking_number: "Booking N°",
                surname: "Room number or reservation surname",
                login_error: "Could not login. Please retry...",
                check_in_date: "Check-in",
                check_out_date: "Check-out",
                toggle_to_check_in_mode: "Enter the dates of your stay",
                toggle_to_booking_number_mode: "Do you have a booking number?",
                confirm: "CONFIRM"
            }
        }
    },
    de: {
        shared: {
            login: {
                insert_data: "Geben Sie Ihre Daten ein",
                access_your_home: "Zugriff auf Ihr Profil!",
                booking_number: "Buchungsnummer",
                surname: "Zimmernummer oder Nachname buchen",
                login_error: "Zugriff auf Ihr Profil nicht möglich. Bitte, wiederholen...",
                check_in_date: "Anreise",
                check_out_date: "Abreise",
                toggle_to_check_in_mode: "Geben Sie die Daten Ihres Aufenthalts ein",
                toggle_to_booking_number_mode: "Haben Sie eine Buchungsnummer?",
                confirm: "LOGIN"
            }
        }
    },
    es: {
        shared: {
            login: {
                insert_data: "Autenticarse",
                access_your_home: "regresar a la pagina principal!",
                booking_number: "numero de reserva",
                surname: "Número de habitación o apellido de la reserva",
                login_error: "No fue posible autenticarse. Por favor, intentelo de nuevo",
                check_in_date: "Fecha de entrada",
                check_out_date: "Fecha de salida",
                toggle_to_check_in_mode: "Escribe las fechas de su estancia",
                toggle_to_booking_number_mode: "¿Tienes un número de reserva?",
                confirm: "LOGIN"
            }
        }
    },
    fr: {
        shared: {
            login: {
                insert_data: "Insérez vos données",
                access_your_home: "pour accéder à votre espace",
                booking_number: "Numéro de réservation",
                surname: "Numéro de chambre ou nom de réservation",
                login_error: "Impossible de se connecter. Veuillez réessayer...",
                check_in_date: "Arrivée",
                check_out_date: "Départ",
                toggle_to_check_in_mode: "Entrez les dates du séjour",
                toggle_to_booking_number_mode: "Avez-vous un numéro de réservation?",
                confirm: "LOGIN"
            }
        }
    },
    it: {
        shared: {
            login: {
                insert_data: "Inserisci i tuoi dati",
                access_your_home: "per accedere alla tua Home!",
                booking_number: "Prenotazione N°",
                surname: "Numero camera o cognome prenotazione",
                login_error: "Non è stato possibile accedere. Si prega di riprovare...",
                check_in_date: "Data Check-in",
                check_out_date: "Data Check-out",
                toggle_to_check_in_mode: "Inserisci le date del soggiorno",
                toggle_to_booking_number_mode: "Hai un numero di prenotazione?",
                confirm: "ACCEDI"
            }
        }
    }
};

export default translations;


// WEBPACK FOOTER //
// ./translations/shared/Login.js